<template>
  <div class="pb-3">
    <b-container fluid class="p-0">
      <main>
        <CommonTitle class="sp-h1-font-size fs-24-bold" :titleProps="'利用規約'"/>
        <b-card class="mt-3">
            <div ref="content"  class="fs-14-regular term-container">
              <span style="white-space: pre-wrap;" v-text="termsOfService" />
            </div>
        </b-card>
      </main>
    </b-container>
    <b-modal centered v-model="modalShow" :title="isLoadingTxt" hide-header hide-footer hide-header-close no-close-on-backdrop no-close-on-esc>
      <CommonLoader :title="isLoadingTxt"/>
    </b-modal>
  </div>
</template>
<script>

// NOTE: ローディングの共通文言を取得
import LoadingTxt from '../../utils/loading-text-util'

// NOTE: 共通タイトルUI
import CommonTitle from '../../components/common/CommonTitle'

// NOTE: トーストの共通文言を取得
import ToastTextUtil from '../../utils/toast-text-util'

// NOTE: 共通エラー処理
import ErrorHandleUtil from '@/utils/error-handle-util'

// Vuex
import { mapActions } from 'vuex'

import CommonLoader from '@/components/common/CommonLoader.vue'

export default {
  components: {
    CommonLoader,
    CommonTitle
  },
  data () {
    return {
      termsOfServiceText: '',
      isLoadingTxt: '',
      modalShow: false
    }
  },
  computed: {
    // NOTE: テキスト表示の際にcomputedを通した方が安全なのでcomputedを使用してます
    termsOfService () {
      return this.termsOfServiceText.replace(/ /g, '\r\n')
    }
  },
  mounted () {
    this.start()
    this.$emit('executionUnreadCount')
  },
  methods: {
    // map Vuex actions
    ...mapActions('mypage', ['getRule']),
    // NOTE: APIを読み込んで取得した後に「termsOfServiceText」にテキストを入れてください
    start () {
      this.isLoadingTxt = LoadingTxt.loadingTxt
      this.modalShow = true
      this.getRule().then(res => {
        this.termsOfServiceText = res.data[0].rule_content
      }).catch(error => {
        console.log(error)
        if (ErrorHandleUtil.authErrorHandle(error, this.$route.path, this.$router)) return
        this.$bvToast.toast(
          error.message,
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
      }).finally(() => {
        this.modalShow = false
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@media screen and (max-width: 480px) {
  .sp-h1-font-size {
    font-size: 1.5rem !important;
  }
}
.wrap {
  white-space: pre;
}
</style>

<style lang="scss" scoped>
.term-container {
  &::-webkit-scrollbar {
    width: 9px;
    background-color: F5F5F5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 12px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #9F9F9F;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 12px;
    background-color: F5F5F5;
  }
}
</style>
